import React from "react";
import { Box, Step, StepLabel, Stepper } from "@mui/material";
import { steps } from "../vendorConfig";
import { StyledConnector, StyledStepIcon } from "../styledComponents";

export const VendorStepper: React.FC<{ activeStep: number }> = ({ activeStep }) => (
  <Box sx={{ maxWidth: { xs: 500, xxl: 625, uhd: 750 }, mx: "auto", mb: 6 }}>
    <Stepper activeStep={activeStep} alternativeLabel connector={<StyledConnector />}>
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel StepIconComponent={StyledStepIcon}>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  </Box>
);
